<template>
  <div class="dashboard-rentabilidad-socios">
    <p>Informe de Rentabilidad para Inversión</p>
    <!-- <p class="description">{{ descripcion }}</p> -->
      <b-table hover
          responsive="sm" 
          class="registro"
          :busy="tableBusy"
          :items="items" 
          :fields="fields">
        <div slot="table-busy" class="text-center">
          <b-spinner class="table-spinner" label="Spinning" />
        </div>
        <!-- <template v-slot:cell(periodo)="data">
          {{ data.item.periodo | fecha }}
        </template> -->
        <template v-slot:cell(rentabilidadNeta)="data">
          {{ data.item.rentabilidadNeta | moneda }}
        </template>
        <template v-slot:cell(pjeReinversion)="data">
          {{ data.item.pjeReinversion | porcentaje }}
        </template>
        <template v-slot:cell(importeReinversion)="data">
          {{ data.item.importeReinversion | moneda }}
        </template>
      </b-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      key: 0,
      items: [],
      fields: [
        { key: 'periodo' },
        { 
          key: 'rentabilidadNeta',
          label: 'Rent.Total Negocio',
          class: 'text-right'
        },
        { 
          key: 'pjeReinversion',
          class: 'text-right'
        },
        { 
          key: 'importeReinversion',
          class: 'text-right'
        },
      ],

      tableBusy: true
    }
  },
  mounted () {
    this.tableBusy = true;
  },
  methods: {
    actualizado() {
      this.key++;
    },
    getIndicador() {
      this.items = this.$store.getters['indicadoresSocios/informeReinversion'];
      this.tableBusy = false;
    },
  }
}
</script>

<style>
  .dashboard-rentabilidad-socios {
    margin-bottom: 30px;
  }
  .dashboard-rentabilidad-socios p {
    font-size: 0.8em;
    font-weight: 700;
    margin-bottom: 20px;
  }

</style>


